<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import IwanButton from '@/comps-sdk/components/button';
  import SelectRow from '@/comps-sdk/components/select-row';
  import { EZoneRetCode } from '@/comps-sdk/constants';
  import { type ICommon, type IZoneRoleSelect } from '@/comps-sdk/interface';

  import UserInfo from './user-info.svelte';

  export let userInfo: ICommon.UserInfo | null;
  export let changeClient = false;
  export let btnText = '确定';
  export let isShowUserInfo = true;
  export let isShowRole = true;
  export let isShowZone = true;
  export let selectedValue = {
    area: {
      id: '',
      name: '',
    },
    role: {
      id: '',
      name: '',
    },
    client: {
      id: '',
      name: '',
    },
  };
  export let guideTips = '';
  export let customDisableBtn: IZoneRoleSelect.ICustomDisabledBtn | null = null;

  let btnDisabled = false;

  $: {
    const { area, role, client } = selectedValue;
    if (isShowRole) {
      btnDisabled = !area.id || !role.id || !client.id;
    } else if (isShowZone) {
      btnDisabled = !area.id || !client.id;
    } else {
      btnDisabled = !client.id;
    }
  }

  const dispatch = createEventDispatcher();

  const handleSelect = (type: string) => {
    dispatch('select-change', type);
  };

  const handleReceive = async () => {
    dispatch('confirm');
  };

  const handleCustomDisabledBtnClick = () => {
    const { code = EZoneRetCode.end } = customDisableBtn!.handleDisableClk();
    console.log('[comps-sdk] zone-role-select handleDisableClk result', code);
    if (code === EZoneRetCode.close) {
      dispatch('close');
    }
  };
</script>

<div class={`zone-role-select_first-panel ${$$restProps.class || ''}`}>
  {#if isShowUserInfo}
    <UserInfo {userInfo} />
  {/if}

  <div class="select-wrapper">
    <SelectRow
      label="客户端"
      disabled={!changeClient}
      selectedValue={selectedValue.client}
      on:click={() => {
        handleSelect('client');
      }}
    />
    {#if isShowZone}
      <SelectRow
        label="区服"
        selectedValue={selectedValue.area}
        on:click={() => {
          handleSelect('area');
        }}
      />
    {/if}
    {#if isShowRole}
      <SelectRow
        label="角色"
        selectedValue={selectedValue.role}
        on:click={() => {
          handleSelect('role');
        }}
      />
    {/if}
  </div>

  <!-- 需保持和 EZoneRoleSelect.SLOTS.beforeConfirmBtn 一致 -->
  <slot name="beforeConfirmBtn" />
  {#if guideTips && btnDisabled}
    <div class="guide-tip">{guideTips}</div>
  {/if}

  <div style="display: flex;align-items: center;">
    {#if customDisableBtn && btnDisabled}
      <IwanButton
        class="ams-button-wrapper"
        disabled={customDisableBtn.needDisable}
        on:click={handleCustomDisabledBtnClick}
      >
        {customDisableBtn.disableText}
      </IwanButton>
      <div style="flex: 0 0 8px" />
    {/if}
    <IwanButton class="ams-button-wrapper" disabled={btnDisabled} on:click={handleReceive}>
      {btnText}
    </IwanButton>
  </div>
</div>

<style lang="scss">
  .zone-role-select_first-panel {
    :global(.ams-button-wrapper) {
      margin: 10px 0;
      text-align: center;
      :global(.iwan-btn) {
        flex: 1;
      }
    }
  }

  .select-wrapper {
    height: 160px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    &.without-userinfo {
      margin-top: 40px;
    }
  }
  .guide-tip {
    margin-top: 8px;
    font-size: 14px;
    color: #e44c5c;
    text-align: center;
  }
</style>
